function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.6437 4.7998H20.5437C22.0437 4.7998 22.7997 5.5078 22.7997 6.9478V17.0518C22.7997 18.4798 22.0437 19.1998 20.5437 19.1998H4.6437C3.1437 19.1998 2.3877 18.4798 2.3877 17.0518V6.9478C2.3877 5.5078 3.1437 4.7998 4.6437 4.7998ZM12.5877 15.1198L20.6757 8.4838C20.9637 8.2438 21.1917 7.6918 20.8317 7.1998C20.4837 6.7078 19.8477 6.6958 19.4277 6.9958L12.5877 11.6278L5.7597 6.9958C5.3397 6.6958 4.7037 6.7078 4.3557 7.1998C3.9957 7.6918 4.2237 8.2438 4.5117 8.4838L12.5877 15.1198Z",
  fill: "#F4EFEA"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.b8a58482.svg";
export { ForwardRef as ReactComponent };